import {
  ArrowLeft,
  BusinessIcon,
  MyselfIcon,
  SomeoneIcon,
} from '@/shared/assets';
import { Button, DashboardDialogProps, Typography } from '@/shared/ui';

import { MoneyFlowType } from '../../model/types';
import { useAddMoney } from '../../model/useAddMoney';
import { useSendMoney } from '../../model/useSendMoney';

interface AddPaymentModalContentProps {
  setStep: (step: MoneyFlowType) => void;
}

const Content = ({ setStep }: AddPaymentModalContentProps) => {
  const resetAddData = useAddMoney((state) => state.resetAddData);
  const resetData = useSendMoney((state) => state.resetData);

  return (
    <div className="mt-1 flex w-full flex-col items-center gap-y-4 pb-4">
      <div className="grid h-[92px] w-full grid-cols-3 gap-x-1">
        <Button
          className="flex h-full w-full flex-col gap-y-4 rounded-3xl px-2 py-4"
          variant="dark-secondary"
          onClick={() => {
            resetAddData();
            setStep('add');
          }}
        >
          <MyselfIcon className="min-h-6 min-w-6" />
          <Typography>Myself</Typography>
        </Button>
        <Button
          className="flex h-full w-full flex-col gap-y-4 rounded-3xl px-2 py-4"
          variant="dark-secondary"
          onClick={() => {
            resetData();
            setStep('send-someone');
          }}
        >
          <SomeoneIcon className="min-h-6 min-w-6" />
          <Typography>Someone</Typography>
        </Button>
        <Button
          className="flex h-full w-full flex-col gap-y-4 rounded-3xl px-2 py-4"
          variant="dark-secondary"
          onClick={() => {
            resetData();
            setStep('send-business');
          }}
        >
          <BusinessIcon className="min-h-6 min-w-6" />
          <Typography>Business</Typography>
        </Button>
      </div>
      <Typography variant="13-r" color="text-base-100">
        We will find the best option for you
      </Typography>
    </div>
  );
};

interface AddPaymentProps {
  setStep: (step: MoneyFlowType) => void;
  onBack: VoidFunction;
  isFirst: boolean;
}

export const addPaymentProps = ({
  setStep,
  onBack,
  isFirst,
}: AddPaymentProps): DashboardDialogProps => {
  return {
    title: 'Who is your recipient?',
    content: <Content setStep={setStep} />,
    animationProps: {
      id: 'choose',
      isFirst: isFirst,
    },
    disableOutsideClick: !isFirst,
    serviceButton: !isFirst
      ? {
          icon: <ArrowLeft className="min-h-6 min-w-6" />,
          onClick: onBack,
        }
      : undefined,
    hideCloseButton: !isFirst,
  };
};
